var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdnn1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d81c3",
      stroke: "none"
    },
    d: "M292 406L420 406C435.121 406 458.403 410.518 470.999 400.61C487.938 387.285 482 359.109 482 340L482 175C482 155.782 488.556 124.265 470.91 111.221C457.091 101.005 434.176 105 418 105L292 105C292 83.2236 297.982 53.4261 278.91 37.8997C263.94 25.7121 241.053 30 223 30L90 30C70.6395 30 48.8508 26.7148 36.2207 45.0008C28.3212 56.4377 30 69.8229 30 83L30 157C30 254.221 27.4776 351.817 30.0147 449C30.4089 464.101 41.8674 476.811 56 480.957C63.7705 483.236 72.9703 482 81 482L127 482L237 482C254.224 482 272.083 484.113 284.1 468.961C297.12 452.544 292 425.697 292 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M54 31L55 32L54 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M275 35L276 36L275 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M43 37L44 38L43 37M279 38L280 39L279 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "none"
    },
    d: "M281 406L265 406C265 419.279 268.501 437.223 258.532 447.699C248.91 457.81 233.637 455 221 455L130 455C111.108 455 71.9562 462.789 60.4792 443.996C54.8877 434.84 57 422.289 57 412L57 343C57 255.435 54.7239 167.531 57.0147 80C57.8055 49.7826 100.624 56.0155 121 57.0401C132.14 57.6003 132.97 67.8176 141.213 71.3966C149.873 75.1566 167.548 72.4001 176.985 71.9807C185.42 71.6059 187.804 60.3738 196 57.804C202.1 55.8915 209.674 57 216 57C231.989 57 252.23 52.9207 261.995 69C267.834 78.6153 265 94.1923 265 105L281 105C281 87.8378 286.952 58.6749 271.96 46.5293C258.826 35.8888 236.78 40 221 40L96 40C79.2673 40 55.8612 35.721 45.108 52.0008C38.325 62.2698 40 76.2862 40 88L40 160C40 253.239 37.7312 346.793 40.0147 440C41.0949 484.096 98.6948 472 129 472L234 472C248.067 472 265.495 474.293 275.471 461.96C286.196 448.701 281 422.122 281 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M282 41L283 42L282 41M265 42L266 43L265 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M37 43L38 44L37 43M54 43L55 44L54 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M267 43L268 44L267 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M270 45L271 46L270 45M45 51L46 52L45 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a12b",
      stroke: "none"
    },
    d: "M143.229 52.0278C138.795 54.7561 140.688 60.094 145.044 61.4275C151.203 63.3129 174.549 64.7262 179.397 60.142C182.365 57.3344 180.593 52.3206 176.941 51.3179C170.409 49.5239 149.009 48.4711 143.229 52.0278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M128 58L129 59L128 58M191 59L192 60L191 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M63 63L64 64L63 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M261 67L262 68L261 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M281 67L281 105L282 105C282 94.0894 285.211 77.0359 281 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "none"
    },
    d: "M254 406C245.44 406 235.244 407.507 227 404.945C197.485 395.773 206 353.559 206 330C206 322.839 209.605 300.775 203.682 296.075C198.524 291.981 190.035 290.314 184 287.719C168.145 280.903 152.024 274.61 136 268.2C131.251 266.3 114.117 262.159 115.752 255.039C117.243 248.545 131.665 245.574 137 243.281C153.176 236.327 169.652 229.939 186 223.4C191.134 221.346 201.728 219.232 204.972 214.502C208.271 209.69 206 197.686 206 192C206 167.647 195.613 114.385 228 106.525C236.475 104.469 245.359 105 254 105C254 96.2855 257.012 80.5926 251.852 73.1852C245.181 63.6089 222.297 68 212 68C207.997 68 202.818 67.1592 199.015 68.6034C190.58 71.8076 189.666 82.4194 179 82.9599C167.565 83.5392 148.722 86.2039 138 82.1065C130.772 79.3443 128.711 69.3539 120.999 68.1481C109.721 66.3847 85.5397 64.618 75.0154 69.0092C70.38 70.9434 68.32 75.2076 68.0432 80C66.3616 109.121 68 138.825 68 168L68 343L68 411C68 418.873 65.4946 432.066 70.0093 438.895C73.8635 444.725 81.7372 444.99 88 445L130 445L218 445C227.3 445 243.264 447.951 250.467 440.606C257.505 433.429 254 415.334 254 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M126 70L127 71L126 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M182 70L183 71L182 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M195 70L196 71L195 70M263 71L264 72L263 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M193 73L194 74L193 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M129 75L130 76L129 75M192 75L193 76L192 75M234 105L235 106L234 105M227 106L228 107L227 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M224 107L225 108L224 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M217 111L218 112L217 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M474 114L475 115L474 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "none"
    },
    d: "M136 255C139.44 260.042 148.468 261.788 154 264C168.681 269.872 183.453 275.654 198 281.85C203.219 284.073 212.769 286.042 215.821 291.213C218.861 296.363 217 306.194 217 312L217 364C217 373.337 215.577 383.742 223.105 390.786C234.038 401.017 260.096 396 274 396L413 396C427.683 396 456.796 401.633 467.211 388.815C477.458 376.202 472 347.332 472 332L472 181C472 164.822 478.358 131.545 463.985 120.419C458.506 116.178 451.511 117 445 117L406 117L286 117C269.103 117 246.223 112.947 230 117.638C216.279 121.605 217 135.542 217 147L217 197C217 203.694 218.854 213.676 216.397 219.957C213.838 226.497 201.915 228.834 196 231.2C176.334 239.066 156.424 249.414 136 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a12b",
      stroke: "none"
    },
    d: "M265 228C258.826 228 248.887 226.097 243.228 228.742C238.791 230.816 240.04 236.575 244.059 238.258C252.183 241.659 264.696 235.043 271.674 241.318C277.973 246.98 282.428 255.643 288.17 262C298.498 273.435 310.726 283.592 323 292.87C328.439 296.982 336.843 305.597 344 305.758C351.637 305.931 360.287 296.665 366 292.373C385.978 277.366 399.499 258.594 416.76 241.318C423.308 234.765 436.871 241.717 444.852 238.106C448.745 236.345 448.857 230.352 444.852 228.603C439.352 226.202 429.953 228 424 228C429.427 208.11 433.595 189.178 422.662 170C403.953 137.182 362.843 144.407 344 172C329.636 143.164 288.5 139.652 269.239 165.001C255.258 183.401 257.131 207.602 265 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "none"
    },
    d: "M326 235C330.414 225.563 333.415 215.531 337.619 206.001C339.036 202.789 341.624 198.309 345.893 199.662C349.552 200.822 350.744 205.862 352 209C355.322 217.297 357.601 227.858 363 235C365.794 229.027 369.862 210.52 377.04 208.971C384.364 207.39 388.335 222.642 392.761 226.397C395.049 228.338 398.194 227.994 401 228C414.527 228.027 416.672 218.097 418.561 206C422.941 177.954 397.103 145.9 368 163.094C361.153 167.139 356.217 173.036 352.49 180C350.751 183.249 349.391 189.078 344.961 189.534C339.388 190.107 337.209 181.664 334.934 178C329.828 169.775 322.558 162.402 313 159.76C284.679 151.931 268.583 179.41 269.979 204C270.346 210.468 272.11 221.632 276.969 226.397C279.04 228.427 282.342 227.995 285 228C289.464 228.009 293.816 228.598 296.957 224.852C300.23 220.948 304.624 208.131 310.985 208.921C318.935 209.909 321.785 229.425 326 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M202 216L203 217L202 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "none"
    },
    d: "M344 219C340.27 228.617 336.869 238.636 332.557 247.999C331.073 251.221 328.29 255.812 324.054 253.914C315.672 250.156 314.542 232.86 309 226C301.743 236.967 298.112 239 285 239C292.461 256.625 313.315 271.134 328 282.576C331.948 285.652 339.606 293.677 345 292.969C350.683 292.223 357.609 284.998 362 281.576C376.843 270.006 395.283 256.077 404 239C389.278 239 388.368 234.821 378 226C376.62 230.08 374.986 234.045 373.281 238L369.85 246C359.122 270.868 349.327 227.022 344 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M210 225L211 226L210 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M175 227L176 228L175 227M170 229L171 230L170 229M143 240L144 241L143 240M138 242L139 243L138 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M163 244L164 245L163 244M158 246L159 247L158 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M126 264L127 265L126 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M165 268L166 269L165 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M158 277L159 278L158 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M192 279L193 280L192 279M197 281L198 282L197 281M185 288L186 289L185 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9a12b",
      stroke: "none"
    },
    d: "M280.318 326.028C275.399 329.319 279.659 334.556 284.005 334.941C314.802 337.674 347.068 335 378 335C384.583 335 404.538 338.322 409.254 333.397C411.876 330.658 410.329 326.289 406.891 325.318C400.728 323.578 392.387 325 386 325L309 325C301.961 325 286.259 322.053 280.318 326.028M280.318 355.028C275.399 358.319 279.659 363.556 284.005 363.941C314.802 366.674 347.068 364 378 364C384.583 364 404.538 367.322 409.254 362.397C411.876 359.658 410.329 355.289 406.891 354.318C400.728 352.578 392.387 354 386 354L309 354C301.961 354 286.259 351.053 280.318 355.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M206 381L207 382L206 381M467 388L468 389L467 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M464 391L465 392L464 391M461 393L462 394L461 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M212 395L213 396L212 395M222 403L223 404L222 403M281 406L281 445L282 445C282 433.828 285.311 416.274 281 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M264 437L265 438L264 437M251 439L252 440L251 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M62 447L63 448L62 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ffff",
      stroke: "none"
    },
    d: "M258 448L259 449L258 448M37 468L38 469L37 468M283 469L284 470L283 469M279 473L280 474L279 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f99f1",
      stroke: "none"
    },
    d: "M275 476L276 477L275 476z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdnn1);
export default __webpack_public_path__ + "static/media/SDNN1.a427b4f789ecb5ed215c4157eb6e8ea6.svg";
export { ForwardRef as ReactComponent };